<div class="heatmap rgb" style="max-height: 320px;">
  @if (ready) {
    <ngx-charts-line-chart #chart1 class="dark"
      [scheme]="colorScheme"
      [results]="chartData"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [legend]="legend"
      [curve]="curve"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [yScaleMin]="min"
      [yScaleMax]="max"
      [autoScale]="autoScale"
      [animations]="animations"
      [showGridLines]="showGridLines"
      [roundDomains]="roundDomains">
    </ngx-charts-line-chart>
  }
  @if (!ready) {
    <div class="d-flex justify-content-center align-items-center" style="height: 320px;">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
</div>